import React from 'react'
import { useNavigate } from "react-router-dom";
import { CheckCircle, } from "lucide-react";
import { GiElectric, GiPowerGenerator } from "react-icons/gi";
import { FaIndustry, FaLightbulb } from "react-icons/fa";
import { MdElectricalServices } from "react-icons/md";
import { RiToolsFill } from "react-icons/ri";
import p1 from "../assets/electricaltwo.jpg";
import p2 from "../assets/electricalbg.jpg";


function ElectricalServices() {
  const navigate = useNavigate();

  return (
    <div className=" w-full font-sans text-gray-800">
      {/* 1. Hero Section */}
      <section
  className="w-full h-[40vh] relative text-white py-20 px-6 text-center bg-cover bg-center"
  style={{
    backgroundImage: `url(${p2})`,
  }}
>
  {/* Overlay */}
  <div className="absolute inset-0 bg-black bg-opacity-50"></div>

  {/* Content */}
  <div className="relative z-10 items-center">
    <h1 className="text-[32px] text-center max-w-4xl m-auto bg-gray-950 bg-opacity-70 text-white px-4 py-6 pb-11 font-bold mb-4">
      Reliable, and Safe Electrical Solutions
    </h1>

    {/* Paragraph visible only on lg and above */}
    <p className="hidden lg:block max-w-2xl mx-auto text-lg lg:text-xl py-6 -top-10 relative bg-orange-500 text-gray-900 bg-opacity-90 mb-6 rounded-lg">
      Delivering top-quality electrical installations, maintenance, and upgrades
    </p>
  </div>
</section>


      
      <section className="py-16 px-6 text-center bg-gray-50">
        <h2 className="text-sm font-bold mb-4 text-orange-600">What We Do</h2>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6">
          Our Electrical Services
        </h2>
        <p className="max-w-4xl mx-auto text-gray-600 leading-relaxed">
          We provide end-to-end electrical services including design,
          installation, testing, commissioning, and maintenance. Our solutions
          strictly adhere to safety standards and regulations, ensuring
          long-lasting, safe, and efficient electrical systems for all
          applications.
        </p>
      </section>

     
      <section className="py-6 px-6 bg-gray-50">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            {
              title: "Residential and Commercial Wiring",
              desc: "Safe, efficient wiring systems for homes, offices, and commercial spaces.",
              icon: <GiElectric className="text-white" size={28} />
            },
            {
              title: "Industrial Power Systems",
              desc: "High-capacity electrical setups designed for heavy industrial loads.",
              icon: <FaIndustry className="text-white" size={28} />
            },
            {
              title: "Lighting Installation & Control Systems",
              desc: "Modern lighting with energy-efficient control and automation.",
              icon: <FaLightbulb className="text-white" size={28} />
            },
            {
              title: "Power Backup & Generator Systems",
              desc: "Reliable backup solutions to keep your operations running during outages.",
              icon: <GiPowerGenerator className="text-white" size={28} />
            },
            {
              title: "Electrical Panel Installation & Upgrades",
              desc: "Installation and modernization of electrical distribution panels.",
              icon: <MdElectricalServices className="text-white" size={28} />
            },
            {
              title: "Preventive & Corrective Maintenance",
              desc: "Routine inspections and repairs to prevent costly breakdowns.",
              icon: <RiToolsFill className="text-white" size={28} />
            }
          ].map((service, idx) => (
            <div
              key={idx}
              className="bg-white p-6 shadow hover:shadow-lg transition flex flex-col"
            >
              <div className="bg-orange-500 w-14 h-14 flex items-center justify-center mb-4">
                {service.icon}
              </div>
              <h3 className="text-lg font-semibold mb-2">{service.title}</h3>
              <p className="text-gray-600 text-sm">{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      
      <section className="py-16 px-6 ">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-10">Why Choose Us</h2>
        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl  mx-auto items-center">

          <div className="flex justify-center">
            <img
              src={p1}
              alt="Electrical services"
              className="w-full  object-cover"
            />
          </div>


          <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-6">
            {[
              "Certified and experienced electricians",
              "Use of high-quality, tested materials",
              "Strict adherence to safety standards",
              "Energy-efficient and sustainable solutions",
              "24/7 emergency support",
            ].map((reason, idx) => (
              <div
                key={idx}
                className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition flex items-center gap-3"
              >
                <CheckCircle className="text-orange-600 flex-shrink-0" size={28} />
                <p className="text-gray-700">{reason}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

     
      <section className="bg-gray-950 text-white py-16 px-6 text-center mb-36">
        <h2 className="text-3xl font-bold mb-4">
          Let’s power your next project — safely and efficiently.
        </h2>
        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
          <button onClick={() => navigate("/contact")} className="bg-orange-500 text-white hover:bg-orange-600  px-6 py-3 rounded-xl font-medium transition">
            Contact Us
          </button>
        </div>
      </section>
    </div>
  )
}

export default ElectricalServices